import messaging from '@/config/firebase'

export async function getFcmToken () {
  try {
    const permission = await Notification.requestPermission()
    if (permission !== 'granted') {
      return null
    }

    const token = await messaging.getToken()
    if (token) {
      localStorage.setItem('fcmToken', token)
    }
    return token || null
  } catch (error) {
    console.error('Error getting FCM token:', error)
    return null
  }
}
